import React from 'react'
import { observer } from 'mobx-react'
import styles from './TabAlerts.module.scss'
import { store } from '../../../store'
import { hasAccess } from '../../../lib/utilsCatalogs'
import { PERMISSIONS } from '../../../models/AbstractCatalogConfig'
import { Button, Checkbox, Form, Input } from 'antd'
import { SingleCatalogService } from '../../../services/SingleCatalogService'
import { TSingleCatalogItem } from '../../../models/SingleCatalogItem'
import { routes } from '../../../config/routes'
import { useNavigate } from '../../../hooks/useNavigate'
import { useParams } from 'react-router'
import { t } from '../../../config/i18n'

interface Props {
  catalogService: SingleCatalogService
}

export const PageCatalogItemDetailTabAlerts = observer(({ catalogService }: Props) => {
  const navigate = useNavigate()
  const params = useParams()
  const { type, id } = params
  const parentId = parseInt(`${params.parentId}`) || 0
  const [formValues, setFormValues] = React.useState<TObjectAny>({})
  const config = catalogService.store.configItemDetails
  const item = catalogService.store.itemDetails

  React.useEffect(() => {
    setFormValues(item.alerts)
  }, [item._id])

  const saveItem = async (item: TSingleCatalogItem, restore = false) => {
    if (await catalogService.saveCatalogItem(item, restore)) {
      catalogService.loadCatalogItems(config.id).catch(window.logger.error)
      navigate(routes.catalogItemList, { type, id: id || '', parentId })
    }
  }

  const onSubmit = async (values: TObjectAny) => {
    const nextItem: TSingleCatalogItem = { ...item, alerts: { ...values } } as TSingleCatalogItem
    await saveItem(nextItem)
  }

  if (store.ui.loading) {
    return null
  }

  const disabled = !item.active || !hasAccess(config, PERMISSIONS.ITEM_UPDATE)

  return (
    <div className={styles.root}>
      <Form
        key={item._id}
        disabled={disabled}
        layout={'vertical'}
        labelCol={{ span: 12 }}
        wrapperCol={{ span: 12 }}
        initialValues={item.alerts || {}}
        autoComplete="off"
        onValuesChange={(_, values) => setFormValues(values)}
        onFinish={onSubmit}
      >
        <Form.Item
          label={t.catalog.confirmationAlert}
          name="confirmationAlert"
        >
          <Input.TextArea />
        </Form.Item>
        <Form.Item
          label={t.catalog.confirmationEmailAlert}
          name="confirmationEmailAlert"
        >
          <Input.TextArea />
        </Form.Item>
        <Form.Item
          label={t.catalog.useConfirmationSmsAlert}
          name="useConfirmationSmsAlert"
          valuePropName="checked"
        >
          <Checkbox disabled={disabled} />
        </Form.Item>
        {formValues.useConfirmationSmsAlert && (
          <Form.Item
            label={t.catalog.confirmationSmsAlert}
            name="confirmationSmsAlert"
          >
            <Input />
          </Form.Item>
        )}
        <Form.Item
          label={t.catalog.selectedServiceAlert}
          name="selectedServiceAlert"
        >
          <Input.TextArea />
        </Form.Item>
        {!!formValues.selectedServiceAlert && (
          <Form.Item
            label={t.catalog.selectedServiceBlock}
            name="selectedServiceBlock"
            valuePropName="checked"
          >
            <Checkbox disabled={disabled} />
          </Form.Item>
        )}

        {item.active && (
          <Form.Item>
            <Button type="primary" htmlType="submit">
              {t.common.save}
            </Button>
          </Form.Item>
        )}
      </Form>
    </div>
  )
})
